import React from 'react';
import PropTypes from 'prop-types';
import TextInput from 'components/templates/admin/internalAdmissonForm/controls/TextInput';
import SelectInput from 'components/templates/admin/internalAdmissonForm/controls/SelectInput';
import DatePickerInput from 'components/templates/admin/internalAdmissonForm/controls/DatePickerInput';
import RadioInput from 'components/templates/admin/internalAdmissonForm/controls/RadioInput';
import CheckboxInput from 'components/templates/admin/internalAdmissonForm/controls/CheckboxInput';
import TimePickerInput from 'components/templates/admin/internalAdmissonForm/controls/TimePickerInput';

const FormInput = ({ type, params, error }) => {
  const components = {
    text: <TextInput {...params} error={error} />,
    select: <SelectInput {...params} error={error} />,
    radio: <RadioInput {...params} error={error} />,
    checkbox: <CheckboxInput {...params} error={error} />,
    time: <TimePickerInput {...params} error={error} />,
    date: <DatePickerInput {...params} error={error} />,
  };
  return <>{components[type] || null}</>;
};
FormInput.propTypes = {
  type: PropTypes.oneOf([
    'text',
    'select',
    'radio',
    'date',
    'radio',
    'checkbox',
    'time',
  ]),
  params: PropTypes.shape({
    id: PropTypes.string,
  }),
  error: PropTypes.string,
};

export default FormInput;
